export function createDigitsArr(digits: string, length: number = digits.length): Array<string> {
  return String(Math.round(Number(digits)))
    .padStart(length, '0')
    .split('');
}
